import { useCallback, useEffect, useRef, useState } from 'react';

const useCountdown = (durationMs = 120_000) => {
  const endTimeRef = useRef(Date.now() + durationMs);

  const getRemaining = () => Math.max(0, endTimeRef.current - Date.now());

  const [remainingMs, setRemainingMs] = useState(getRemaining);

  useEffect(() => {
    const interval = setInterval(() => {
      const ms = getRemaining();
      setRemainingMs(ms);
      if (ms === 0) clearInterval(interval);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const reset = useCallback(() => {
    endTimeRef.current = Date.now() + durationMs;
    setRemainingMs(durationMs);
  }, [durationMs]);

  const totalSeconds = Math.ceil(remainingMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return {
    remainingMs,
    remainingSeconds: totalSeconds,
    minutes,
    seconds,
    isFinished: remainingMs === 0,
    reset,
  };
};

export default useCountdown;
